import { render, staticRenderFns } from "./RouterBreadcrumb.vue?vue&type=template&id=68a92e39&lang=pug&"
import script from "./RouterBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./RouterBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RouterBreadcrumb.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
installComponents(component, {
  VBreadcrumbs,
})
